// extracted by css-extract-rspack-plugin
export default {"root":"znVUY2"};